module.exports = __webpack_public_path__ + "static/media/education-object-3-2-1.bbcadcbb.svg";